class DispatchNote {
    id = null;
    number = '';
    time_of_issue = null;
    currency = '';
    currency_rate = 1;
    discount = 0;
    amount = 0;
    history = [];
    tax_system = false;
    footer = '';
    user_id = null;
    customer_id = null;
    customer_data = {};
    sequence = 0;
    device = '';
    location = '';
    dispatch_note_sequence_id = null;
    zki = '';
    jir = '';
    hash = '';
    items = [];
    ppo = false;
    locale = '';
    iban = '';
    swift = '';
    ppo_text = '';
    payment_method_id = null;
    order_form = '';
    shipping_method = '';
    received_by = '';
    invoice_id = null;
    offer_id = null;
    show_financial_data = true;

    constructor(data, validation = false) {
        this.currency = 'EUR';

        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = '';
            }
        }
    }

    Fill(data) {
        for (const [key] of Object.entries(this)) {
            if (data[key] !== undefined) {
                this[key] = data[key];
            }
        }
    }
}

export default DispatchNote;
